/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConceptSummaryDto { 
    id: string;
    type: ConceptSummaryDto.TypeEnum;
    title: string;
    author: string;
    /**
     * Latest Git commit author for the document file, when available.
     */
    lastEditedBy?: string | null;
    created: string;
    lastModified?: string | null;
    commitTimestamp?: string | null;
    categories: Array<string>;
    epic?: string | null;
    openComments: number;
    relativePath?: string;
}
export namespace ConceptSummaryDto {
    export const TypeEnum = {
        Concept: 'concept'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


